// This icon file is generated automatically.
var PUpOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.91 9.8l-5.5-7.6a.5.5 0 00-.81 0L.09 9.8c-.06.08 0 .2.1.2h1.17c.08 0 .15-.04.2-.1L6 3.78l4.44 6.12c.05.06.12.1.2.1h1.17c.1 0 .16-.12.1-.2z", "fill-rule": "nonzero" } }] }, "name": "p-up", "theme": "outlined" };
export default PUpOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PUpOutlined.js
// module id = 3713
// module chunks = 0